"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _pclnModal = require("pcln-modal");

var _pclnDesignSystem = require("pcln-design-system");

var _Card = _interopRequireDefault(require("../../structure/Card"));

var _CardHeader = _interopRequireDefault(require("../../structure/CardHeader"));

var _CardActions = _interopRequireDefault(require("../../structure/CardActions"));

var _CardSection = _interopRequireDefault(require("../../structure/CardSection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledModal = (0, _styledComponents["default"])(_pclnModal.Modal).withConfig({
  componentId: "zggpzg-0"
})(["padding:0;overflow-y:hidden;box-shadow:none;> div > div{overflow-y:hidden;> button{margin:", "px;}}"], (0, _themeGet.themeGet)('space.3'));
var Dialog = (0, _react.memo)(function (_ref) {
  var className = _ref.className,
      isOpen = _ref.isOpen,
      title = _ref.title,
      subTitle = _ref.subTitle,
      footer = _ref.footer,
      children = _ref.children,
      hasDividers = _ref.hasDividers,
      onClose = _ref.onClose;
  return _react["default"].createElement(StyledModal, {
    className: className,
    isOpen: isOpen,
    onClose: onClose,
    bg: "transparent",
    width: ['800px'],
    disableCloseButton: false,
    enableOverflow: true
  }, _react["default"].createElement(_Card["default"], {
    hasDividers: hasDividers
  }, title && _react["default"].createElement(_CardHeader["default"], {
    title: title,
    subTitle: subTitle
  }), _react["default"].createElement(_CardSection["default"], null, _react["default"].createElement(_pclnDesignSystem.Flex, {
    mt: title ? 0 : 4
  }, children)), footer && _react["default"].createElement(_CardActions["default"], {
    backgroundColor: "background.lightest"
  }, footer)));
});
Dialog.displayName = 'Dialog';
Dialog.propTypes = {
  className: _propTypes["default"].string,
  isOpen: _propTypes["default"].bool.isRequired,
  title: _propTypes["default"].node,
  subTitle: _propTypes["default"].node,
  footer: _propTypes["default"].node,
  children: _propTypes["default"].node.isRequired,
  hasDividers: _propTypes["default"].bool,
  onClose: _propTypes["default"].func.isRequired
};
Dialog.defaultProps = {
  className: '',
  hasDividers: false
};
var _default = Dialog;
exports["default"] = _default;